import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import EmptyLeasePage from '@rental-manager/pages/Onboarding/EmptyLeasePage/component';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { resetNewTermSettings } from '@rental-manager/actions/DashboardActions';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => ({
  propertyId,
  rentalProtectionDisclaimers: state.payments.landlord.property.rentalProtectionDisclaimers,
  listingAlias: state.payments.landlord.property.listingAlias,
});

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  goToSetupPaymentManually: () =>
    Promise.resolve().then(() => dispatch(push(baseUrl + paths.dashboard.areYouSurePage))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmptyLeasePage);
